import * as React from 'react';
// import FMenu from '@/components/FMenu';

export default function () {
  return (
    <div>1234</div>
  );
}
